import { Navigate } from "react-router-dom"
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Appointments from "../pages/Appointments/index"
import AppointmentsPublic from "../pages/AppointmentsPublic/index"

const userRoutes = [
  { path: "/book-appointment", component: <Appointments /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/book-appointment" />,
  },
  { path: "*", component: <Navigate to="/" /> },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/no-layout", component: <AppointmentsPublic /> },
]

export { userRoutes, authRoutes }
